import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { EnrollmentEmailFormValues } from '../../../types/forms';
import { useCallback } from 'react';
import { getTextContentFromMarkdown } from '../utils';
import { MAIL_CONTENT_CHARS_LIMIT } from '../consts';

const enrollmentEmailSchema = z.object({
    subject: z.string().min(1, 'Subject is required'),
    content: z
        .string()
        .min(1, 'Content is required')
        .refine(
            (val) => {
                const textContent = getTextContentFromMarkdown(val);
                return textContent.length <= MAIL_CONTENT_CHARS_LIMIT;
            },
            {
                message: `Content must be ${MAIL_CONTENT_CHARS_LIMIT} characters or less.`
            }
        ),
    recipientType: z.enum(['unpaired', 'groupOU']),
    tokenType: z.enum(['silverfort', 'thirdParty']),
    tokenTypeId: z.number().optional(),
    companyLogoUrl: z.union([z.string().url(), z.literal(''), z.undefined()])
});

export const ENROLLMENT_EMAIL_REQUEST_DEFAULT_FORM_VALUES: EnrollmentEmailFormValues = {
    subject: '',
    content: '',
    recipientType: 'unpaired',
    tokenType: 'silverfort',
    tokenTypeId: undefined,
    companyLogoUrl: undefined
};

export const useSendEnrollmentRequestForm = (defaultValues: EnrollmentEmailFormValues) => {
    const formMethods = useForm<EnrollmentEmailFormValues>({
        resolver: zodResolver(enrollmentEmailSchema),
        defaultValues: defaultValues
    });

    const resetToDefaults = useCallback(() => {
        formMethods.reset(ENROLLMENT_EMAIL_REQUEST_DEFAULT_FORM_VALUES);
    }, [formMethods]);

    return { formMethods, resetToDefaults };
};
